import React, {useContext} from 'react';

import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";

import {RecruitContact} from "../types";
import BasedataAddress, {AddressProps} from "./BasedataAddress";
import {formatDateToLocale} from "../../utils";
import {OAuthContext} from "../../../../context/OAuthContext";

interface BasedataContactsProps extends AddressProps {
    contacts: Array<RecruitContact>;
    mandate: number;
}

const BasedataContacts: React.FC<BasedataContactsProps> = (props) => {
    const {t} = useTranslation('common');
    const {oauthData} = useContext(OAuthContext);

    const {
        contacts,
        recruitIsCompany,
        postCode,
        country,
        fax,
        houseNumber,
        mobile,
        phone,
        street,
        city,
        mandate,
        streetHouseNumber,
    } = props;

    if (contacts === undefined || contacts === null || contacts.length === 0)
        return null;

    return (
        <>
            {contacts.map(({
                               salutation,
                               firstName,
                               lastName,
                               birthDate,
                               xRecruitBirthName,
                               xRecruitBirthPlace,
                               xRecruitNationality,
                               xRecruitSocialSecurityNumber
                           }, idx) => {
                return <React.Fragment key={idx}>
                    <Typography variant="body1">{t(salutation)}</Typography>
                    <Typography variant="body1">{firstName} {lastName}</Typography>
                    {birthDate && <Typography variant="body1" sx={{mt: 1, mb: 1}}>
                        {t("birth_date")} {birthDate ? formatDateToLocale(birthDate, oauthData) : ""}
                    </Typography>}
                    {mandate === 4 && <Typography variant="body1">
                        {t('birth_name')}: {xRecruitBirthName ?? t('Kein Eintrag')}
                    </Typography>}
                    {mandate === 4 && <Typography variant="body1">
                        {t('birth_place')}: {xRecruitBirthPlace ?? t('Kein Eintrag')}
                    </Typography>}
                    {mandate === 4 && <Typography variant="body1">
                        {t('nationality')}: {xRecruitNationality ?? t('Kein Eintrag')}
                    </Typography>}
                    {mandate === 4 && <Typography variant="body1">
                        {t('social_security_number')}: {xRecruitSocialSecurityNumber ?? t('Kein Eintrag')}
                    </Typography>}
                    {!recruitIsCompany &&
                        <BasedataAddress recruitIsCompany={recruitIsCompany} postCode={postCode} city={city}
                                         street={street} houseNumber={houseNumber} streetHouseNumber={streetHouseNumber}
                                         country={country} phone={phone} mobile={mobile} fax={fax}/>}
                </React.Fragment>
            })}
        </>
    );
};

export default BasedataContacts;